import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Stadistics } from '../models/stadistics/stadistics';
import { Observable } from 'rxjs';
import { HttpUtil } from '../utils/http-util';

@Injectable({
  providedIn: 'root'
})
export class StadisticsService {

  constructor(
    private _http: HttpClient
  ) { }

  public getMainStatistics(years?: number): Observable<Stadistics> {
    return this._http.get<Stadistics>(`${environment.api.url}/Stadistics`,
      {
        params: HttpUtil.toHttpParams({
          Years: years
        })
      }
    );
  }

}